import React from "react";
import TonalBadge from "@/components/TonalBadge";

// Asset status badge — color is driven by the asset_status taxonomy value's Badge Color.
export default function StatusBadge({ status }) {
  return (
    <TonalBadge
      listType="asset_status"
      label={status}
      testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    />
  );
}
